import { DateTime } from 'luxon'

import { ZoneStateResponseDTO } from '@core/api/dtos/response/zone/state'
import {
	ZoneState,
	ZoneStateStatus,
	ZoneStateState,
	ZoneStateWarning,
} from '@core/api/entities/zone/state'

export class StateMapper {
	static toEntity = (dto: ZoneStateResponseDTO): ZoneState => {
		return new ZoneState({
			status: dto.status as ZoneStateStatus,
			warnings: dto.warnings.map((warning) =>
				ZoneStateWarning.create({
					code: warning.code,
					message: warning.message,
					email: warning.email,
				})
			),
			lastSeen: dto.last_seen ? DateTime.fromISO(dto.last_seen) : null,
			startedPlaying: dto.started_playing
				? DateTime.fromISO(dto.started_playing)
				: null,
			appVersion: dto.app_version,
			osVersion: dto.os_version,
			state: dto.state as ZoneStateState,
			volume: dto.volume,
			audioDevice: dto.audio_device,
			lastUpdated: dto.last_updated ? DateTime.fromISO(dto.last_updated) : null,
		})
	}
}
